import { render, staticRenderFns } from "./modal-block-create.vue?vue&type=template&id=30f60103&"
import script from "./modal-block-create.vue?vue&type=script&lang=js&"
export * from "./modal-block-create.vue?vue&type=script&lang=js&"
import style0 from "./modal-block-create.vue?vue&type=style&index=0&id=30f60103&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports